import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function SalaryInformation() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();

  return (
    <fieldset>
      <legend>{t("Salary Information")}</legend>
      <input
        name="salaryInformation"
        onChange={onChange}
        value={searchObject.salaryInformation || ""}
        className="form-control"
      />
    </fieldset>
  );
}
